import { render, staticRenderFns } from "./TeamIcon.vue?vue&type=template&id=437f9fc4&scoped=true"
import script from "./TeamIcon.vue?vue&type=script&lang=js"
export * from "./TeamIcon.vue?vue&type=script&lang=js"
import style0 from "./TeamIcon.vue?vue&type=style&index=0&id=437f9fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437f9fc4",
  null
  
)

export default component.exports